import PtoTemplateDiffTable from './PtoTemplateDiffTable'

export default PtoTemplateDiffTable
